import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';

import {
  FormModeEnum,
  ToolbarItem,
  TableActionParams,
  TableSettings,
  AuthenticationService,
  NotificationService,
  ModalService,
  BackendService,
} from 'beyond-util';
import { DummyService } from '../../../services/dummy.service';
import { DummySettingsService } from '../../../services/dummy-settings.service';
import { SifarnikBase } from '../sifarnik-base/sifarnik-base';

@Component({
  selector: 'app-vrsta-zabrane',
  templateUrl: './vrsta-zabrane.component.html',
})
export class VrstaZabraneComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private _subscriptions: Array<Subscription> = [];
  private _documentListSource = new Subject<any>();

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    private _authenticationService: AuthenticationService,
    protected _notificationService: NotificationService,
    private _dummyService: DummyService,
    private _dummySettingsService: DummySettingsService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  changeName() {
    if (typeof this.order === 'undefined') {
      return;
    }

    if (this.order.hasOwnProperty('naziv')) {
      this.name = this.order.naziv;
    } else if (this.mode === FormModeEnum.Add) {
      this.name = 'Nova vrsta zabrane';
    } else if (this.order.hasOwnProperty('id')) {
      this.name = 'Vrsta zabrane';
    }
  }

  loadSettings() {
    const data = this._dummySettingsService.getVrstaZabraneSettings();
    this.setSettings(data);
    this.setAllFields();
    this.firstTableLoad();
  }

  refreshTable() {
    const data = {
      documentId: 'VrstaZabrane',
      result: this._dummyService.dummyVrsteZabrane,
      pageSize: 10,
      pageNumber: 1,
      count: this._dummyService.dummyVrsteZabrane.push.length,
      menuCalled: false,
      error: 0,
    };

    for (let i = 0; i < this._dummyService.dummyVrsteZabrane.length; i++) {
      this._dummyService.dummyVrsteZabrane[i].id = i + 1;
    }

    this.orderListCount = data.count;
    this.orderList = data.result;
    this._documentListSource.next(data);
  }

  addOrder() {
    // TODO: Zavrsiti kad bude gotov backend.
  }

  updateOrder() {
    // TODO: Zavrsiti kad bude gotov backend.
  }

  // poslati order da ga deletuje
  onDeleteConfirm() {
    const index = this._dummyService.dummyVrsteZabrane.findIndex(
      u => u.id === this.order.id
    );
    this._dummyService.dummyVrsteZabrane.splice(index, 1);
    this._notificationService.openNoty('Uspešno brisanje');

    if (FormModeEnum.View) {
      this.changeMode(FormModeEnum.Table);
    }

    this.refreshTable();
  }

  onTableActionUpdate(event: TableActionParams) {
    super.onTableActionUpdate(event);
    this._backendService
      .editOrder(
        this.identity.documentId,
        event.document,
        this._authenticationService.getUser().username
      )
      .subscribe(() => {
        this.refreshTable();
      });
  }

  onTableActionView() {
    this.setToolbarOptions({
      items: [ToolbarItem.ItemEdit(true, !this.order.status)],
    });

    this.changeMode(FormModeEnum.View);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/vrsta-zabrane/vrsta-zabrane.component.ts